import Offcanvas from 'react-bootstrap/Offcanvas';
import Trumbowyg from 'react-trumbowyg';
import SequenceService from '../../Services/SequenceService';
import $ from 'jquery';
import UtilsService from '../../Services/UtilsService';
import { useEffect, useState } from 'react';
import PubSub from 'pubsub-js';
import { DEFAULT_VARIABLES_FOR_PREVIEW, EDITOR_BUTTONS } from '../../constants';
import UserService from '../../Services/UserService';
import AuthService from '../../Services/AuthService';
import TemplatesService from '../../Services/TemplatesService';

const EDITOR_ID = 'react-trumbowyg';

// Variables válidas organizadas por categorías
const VALID_VARIABLES = {
    user: [
        { name: 'User Full Name', variable: '{{user_fullname}}' },
        { name: 'User Name', variable: '{{user_name}}' },
        { name: 'User First Name', variable: '{{user_first_name}}' },
        { name: 'Account First Name', variable: '{{account_first_name}}' },
        { name: 'Lead First Name', variable: '{{lead_first_name}}' },
    ],
    profile: [
        { name: 'Profile URL', variable: '{{profile_url}}' },
        { name: 'Background', variable: '{{background}}' },
        { name: 'City', variable: '{{city}}' },
        { name: 'Country', variable: '{{country}}' },
        { name: 'Rate', variable: '{{rate}}' },
        { name: 'Requested Work', variable: '{{requested_work}}' }
    ]
};

function TemplateStepOffcanvas({ show, onClose, selectedStep, setSelectedStep, onRefresh }) {

    const [preview, setPreview] = useState('');
    const [user, setUser] = useState({});
    const [selectedVariationIndex, setSelectedVariationIndex] = useState(0);

    useEffect(() => {
        console.log('useEffect', show);
        getCurrentUser();
        if (show && user) {
            initializeEditor();
            listenForEditorChanges();
            console.log($('#react-trumbowyg'));
        }
    }, [show]);

    // Inicializar variaciones si no existen
    useEffect(() => {
        if (selectedStep && (!selectedStep.variations || selectedStep.variations.length === 0)) {
            const updatedStep = {
                ...selectedStep,
                variations: [{
                    name: "Default",
                    body: selectedStep.body || "",
                    textBody: selectedStep.textBody || ""
                }]
            };
            setSelectedStep(updatedStep);
        }
    }, [selectedStep]);

    async function getCurrentUser() {
        let user = await AuthService.getCurrentUser();
        let profile = await UserService.getUserProfile();
        user.profile = profile;
        setUser(user)
    }

    function handleClose() {
        onClose();
    }

    // Función para insertar variable en el editor
    function insertVariable(variable) {
        const editor = $(`#${EDITOR_ID}`);
        if (editor.length) {
            // Enfocar el editor primero
            editor.trumbowyg('focus');

            // Usar document.execCommand para insertar en la posición del cursor
            document.execCommand('insertHTML', false, variable);

            // Generar preview después de insertar
            setTimeout(() => {
                generatePreview();
            }, 100);

            // Mostrar notificación
            PubSub.publish('show-basic-notification', {
                title: 'Variable Inserted',
                message: `Variable ${variable} has been inserted at cursor position`
            });
        }
    }

    function replaceBodyWithUserProfile(replacedBody, user) {
        if (user && user.name) {
            let first_name = user.name.split(' ')[0];
            let { profile } = user;

            if (profile) {
                let { profile_url, city, country, background, requested_work, first_name, rate } = profile;

                if (profile_url) {
                    replacedBody = replacedBody.replace(new RegExp(`{{profile_url}}`, 'g'), user.profile.profile_url);
                }

                if (background) {
                    replacedBody = replacedBody.replace(new RegExp(`{{background}}`, 'g'), user.profile.background);
                }

                if (city) {
                    replacedBody = replacedBody.replace(new RegExp(`{{city}}`, 'g'), user.profile.city);
                }

                if (country) {
                    replacedBody = replacedBody.replace(new RegExp(`{{country}}`, 'g'), user.profile.country);
                }

                if (rate) {
                    replacedBody = replacedBody.replace(new RegExp(`{{rate}}`, 'g'), rate);
                }

                if (requested_work) {
                    replacedBody = replacedBody.replace(new RegExp(`{{requested_work}}`, 'g'), requested_work);
                }

                if (first_name) {
                    replacedBody = replacedBody.replace(new RegExp(`{{account_first_name}}`, 'g'), first_name);
                    replacedBody = replacedBody.replace(new RegExp(`{{user_first_name}}`, 'g'), first_name);
                }
            }

            replacedBody = replacedBody.replace(new RegExp(`{{user_fullname}}`, 'g'), user.name);
            replacedBody = replacedBody.replace(new RegExp(`{{user_name}}`, 'g'), user.name);
            replacedBody = replacedBody.replace(new RegExp(`{{user_first_name}}`, 'g'), first_name);
            replacedBody = replacedBody.replace(new RegExp(`{{account_first_name}}`, 'g'), first_name);
        }

        return replacedBody;
    }

    function generatePreview() {
        let html = $(`#${EDITOR_ID}`).trumbowyg('html');
        console.log('(info) - generating preview...');

        let replacedBody = html;
        let replacedSubject = selectedStep.subject;

        replacedBody = replaceBodyWithUserProfile(replacedBody, user);

        for (let key in DEFAULT_VARIABLES_FOR_PREVIEW) {
            let value = DEFAULT_VARIABLES_FOR_PREVIEW[key];
            replacedBody = replacedBody.replace(new RegExp(`{{${key}}}`, 'g'), value);
            replacedSubject = replacedSubject.replace(new RegExp(`{{${key}}}`, 'g'), value);
        }

        let preview = `
        <div><b>To:</b> Example Contact <example@google.com> </div>
        <div><b>Subject:</b> ${replacedSubject}</div>
        <div><br /></div>
        ${replacedBody}`;

        setPreview(preview);
    }

    async function updateTemplateStep(step) {
        let html = $(`#${EDITOR_ID}`).trumbowyg('html');

        // Actualizar la variación seleccionada
        const updatedStep = { ...step };
        if (updatedStep.variations && updatedStep.variations[selectedVariationIndex]) {
            updatedStep.variations[selectedVariationIndex].body = html;
            updatedStep.variations[selectedVariationIndex].textBody = UtilsService.convertHtmlToText(html);
        }

        await TemplatesService.updateTemplateStep(selectedStep._id, updatedStep);

        PubSub.publish('show-basic-notification', { title: 'Success', message: 'Step saved successfully' });
        PubSub.publish('refresh.sequence.detail');
        onRefresh();
    }

    async function sendTestEmail() {
        let subject = await UtilsService.replaceTextWithDefaultVariables(selectedStep.subject);
        let body = $(`#${EDITOR_ID}`).trumbowyg('html');
        let bodyReplaced = replaceBodyWithUserProfile(body, user);
        bodyReplaced = await UtilsService.replaceTextWithDefaultVariables(bodyReplaced);

        await UserService.sendTestEmailToMe({ subject, body: bodyReplaced });
        PubSub.publish('show-basic-notification', { title: 'Success', message: 'Test email sent successfully' });
    }

    async function initializeEditor() {
        await UtilsService.waitForElement(`#${EDITOR_ID}`);
        console.log('initializeEditor');
        UtilsService.convertParagraphsToDivs(EDITOR_ID)
    }

    async function listenForEditorChanges() {
        await UtilsService.waitForElement(`#${EDITOR_ID}`);
        generatePreview();
        $(`#${EDITOR_ID}`).on('tbwchange', function () {
            generatePreview();
        });
    }

    // Funciones para gestionar variaciones
    function addVariation() {
        const newVariation = {
            name: `Variation ${selectedStep.variations.length + 1}`,
            body: "",
            textBody: ""
        };

        const updatedStep = {
            ...selectedStep,
            variations: [...selectedStep.variations, newVariation]
        };

        setSelectedStep(updatedStep);
        setSelectedVariationIndex(selectedStep.variations.length);
    }

    function removeVariation(index) {
        if (selectedStep.variations.length <= 1) {
            PubSub.publish('show-basic-notification', {
                title: 'Error',
                message: 'Cannot remove variation. Minimum 1 variation required.'
            });
            return;
        }

        const updatedVariations = selectedStep.variations.filter((_, i) => i !== index);
        const updatedStep = {
            ...selectedStep,
            variations: updatedVariations
        };

        setSelectedStep(updatedStep);

        if (selectedVariationIndex >= index && selectedVariationIndex > 0) {
            setSelectedVariationIndex(selectedVariationIndex - 1);
        }
    }

    function updateVariationName(index, name) {
        const updatedStep = { ...selectedStep };
        if (updatedStep.variations[index]) {
            updatedStep.variations[index].name = name;
            setSelectedStep(updatedStep);
        }
    }

    function selectVariation(index) {
        setSelectedVariationIndex(index);
        // Actualizar el editor con el contenido de la variación seleccionada
        if (selectedStep.variations[index]) {
            setTimeout(() => {
                $(`#${EDITOR_ID}`).trumbowyg('html', selectedStep.variations[index].body);
                generatePreview();
            }, 100);
        }
    }

    // Obtener la variación actual
    const currentVariation = selectedStep.variations && selectedStep.variations[selectedVariationIndex]
        ? selectedStep.variations[selectedVariationIndex]
        : { name: "Default", body: "", textBody: "" };

    return (
        <Offcanvas
            backdrop={false}
            style={{ width: '100vw', top: '55px' }}
            placement="end"
            show={show}
            onHide={onClose}
        >
            <Offcanvas.Header>
                <Offcanvas.Title className="d-flex justify-content-between w-100">
                    <button
                        onClick={handleClose}
                        className="btn btn-secondary btn-sm">Cancel</button>

                    <div>
                        <button
                            onClick={sendTestEmail}
                            className="btn btn-secondary btn-sm me-2">
                            Send test email to me
                        </button>
                        <button
                            onClick={async () => {
                                updateTemplateStep(selectedStep);
                                handleClose();
                            }}
                            className="btn btn-primary btn-sm">
                            Save
                        </button>
                    </div>
                </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="sequence-detail-container">

                <div className="card bg-white card-shadow">
                    <div className="card-header bg-white">
                        <div className="bold">Edit template</div>
                    </div>
                    <div className="card-body fs-13">
                        <div className="row">
                            <div className="col-6">
                                {/* Gestor de Variaciones */}
                                <div className="mb-3">
                                    <label className="fs-14 bold">Variations</label>
                                    <div className="d-flex align-items-center mb-2">
                                        <select
                                            className="form-select me-2"
                                            value={selectedVariationIndex}
                                            onChange={(e) => selectVariation(parseInt(e.target.value))}
                                        >
                                            {selectedStep.variations && selectedStep.variations.map((variation, index) => (
                                                <option key={index} value={index}>
                                                    {variation.name}
                                                </option>
                                            ))}
                                        </select>
                                        <button
                                            onClick={addVariation}
                                            className="btn btn-success btn-sm me-1"
                                        >
                                            <i className="fas fa-plus"></i>
                                        </button>
                                        <button
                                            onClick={() => removeVariation(selectedVariationIndex)}
                                            className="btn btn-danger btn-sm"
                                            disabled={selectedStep.variations && selectedStep.variations.length <= 1}
                                        >
                                            <i className="fas fa-trash"></i>
                                        </button>
                                    </div>

                                    {/* Editor de nombre de variación */}
                                    <input
                                        type="text"
                                        value={currentVariation.name}
                                        onChange={(e) => updateVariationName(selectedVariationIndex, e.target.value)}
                                        className="form-control fs-13 mb-2"
                                        placeholder="Variation name"
                                    />
                                </div>

                                <label className="fs-14 bold">Subject (Shared)</label>
                                <input type="text"
                                    value={selectedStep.subject}
                                    onChange={(e) => {
                                        selectedStep.subject = e.target.value;
                                        setSelectedStep({ ...selectedStep });
                                    }}
                                    className="form-control fs-13 mb-3" />



                                <Trumbowyg
                                    id={EDITOR_ID}
                                    data={currentVariation.body}
                                    semantic={false}
                                    buttons={EDITOR_BUTTONS}
                                    placeholder='Type your text!'
                                />

                                {/* Variables Buttons */}
                                <div className="mb-3">
                                    <label className="fs-14 bold">Insert Variables</label>

                                    {/* Lead Variables */}
                                    <div className="mb-2">
                                        <small className="text-muted">Lead Variables:</small>
                                        <div className="d-flex flex-wrap gap-1 mt-1">
                                            {VALID_VARIABLES.user.map((variable, index) => (
                                                <button
                                                    key={index}
                                                    onClick={() => insertVariable(variable.variable)}
                                                    className="btn btn-outline-primary btn-sm"
                                                    title={variable.name}
                                                >
                                                    {variable.name}
                                                </button>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Profile Variables */}
                                    <div className="mb-2">
                                        <small className="text-muted">Profile Variables:</small>
                                        <div className="d-flex flex-wrap gap-1 mt-1">
                                            {VALID_VARIABLES.profile.map((variable, index) => (
                                                <button
                                                    key={index}
                                                    onClick={() => insertVariable(variable.variable)}
                                                    className="btn btn-outline-secondary btn-sm"
                                                    title={variable.name}
                                                >
                                                    {variable.name}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                </div>

                                {user && user.role === 'admin' && (
                                    <div>
                                        <div className='bold mb-3'>Additional options:</div>
                                        <div className="row">
                                            <div className="col-3">
                                                <div className="form-group">
                                                    <label>Days wait</label>
                                                    <input type="number"
                                                        value={selectedStep.daysWait}
                                                        onChange={(e) => {
                                                            selectedStep.daysWait = e.target.value;
                                                            setSelectedStep({ ...selectedStep });
                                                        }}
                                                        className="form-control fs-13" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="col-6">
                                <label className="fs-14 bold">Generate Preview for Contact (optional)</label>

                                <select
                                    className="form-select"
                                    name="select-123" placeholder="Choose a contact">
                                    <option value="">Jeb Smith</option>
                                </select>

                                <div className="mt-3 ">
                                    <div className='preview-step-div'
                                        dangerouslySetInnerHTML={{ __html: preview }}>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default TemplateStepOffcanvas;